import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { verifyEmailUser } from '../../store/actions/authActions';
import '../start/PasswordGate.css';
import './LoginPage.css';

const VerifyEmailPage = ({ loading, verifyEmailUserAction }) => {
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Verifying your email...');

  const token = React.useMemo(() => {
    const params = new URLSearchParams(location.search || '');
    return params.get('token') || '';
  }, [location.search]);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const result = await verifyEmailUserAction({ token });
        if (cancelled) return;
        setStatus('success');
        setMessage('Email verified! Taking you in...');
        setTimeout(() => {
          history.push(result.redirectTo || '/subscription');
        }, 1200);
      } catch (err) {
        if (cancelled) return;
        setStatus('error');
        setMessage(err.message || 'Verification failed');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, verifyEmailUserAction, history]);

  return (
    <div className="xk-gate">
      <div className="xk-gate__card xk-login-card">
        <img
          src={`${process.env.PUBLIC_URL || ''}/XLog3D Logo_Red.png`}
          alt="XLog3D"
          className="xk-gate__logo"
        />

        <h2 className="xk-gate__title">Verify Email</h2>

        <div className={status === 'error' ? 'xk-gate__error' : 'xk-login-info'}>
          {loading && status === 'verifying' ? 'Please wait...' : message}
        </div>

        {status === 'error' && (
          <div className="xk-login-links">
            <button
              type="button"
              className="xk-login-link"
              onClick={() => history.push('/login')}
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

VerifyEmailPage.propTypes = {
  loading: PropTypes.bool,
  verifyEmailUserAction: PropTypes.func.isRequired,
};

VerifyEmailPage.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
});

const mapDispatchToProps = {
  verifyEmailUserAction: verifyEmailUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailPage);
